
import React from 'react'
import {Grid, Tooltip,  Typography, Collapse, IconButton, List, Menu, Divider, Box } from '@mui/material'
import { NavLink, Link, useLocation } from 'react-router'
// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import Share from '@mui/icons-material/Share'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddMarketplace from '@/housefolios-components/Marketplace/AddMarketplace'
import RemoveSharedMarketplace from '@/housefolios-components/Marketplace/RemoveSharedMarketplace'
import ShareMarketplace from '@/housefolios-components/Marketplace/ShareMarketplace'
import EditMarketplace from '@/housefolios-components/Marketplace/EditMarketplace'

import {
  sidebarActionsBtnSx,
  sidebarNavActive,
  sidebarRowActionsColSx,
  sidebarRowCountColSx,
  sidebarRowGridSx,
  sidebarRowNameSx,
  sidebarSharedSectionIconSx,
  sidebarSharedSectionLabelSx,
} from '@/layout-blueprints/chromeComponentSx'

function marketplaceNavActive(isSelected, onPage) {
  return sidebarNavActive(isSelected, onPage)
}

const MarketplacesSection = (props) => {
  const {
    marketplaces,
    sharedMarketplaces,
    orgId,
    marketplacesDropdownOpen,
    toggleMarketplacesDropdown,
    handleMarketplace,
    activeMarketplaceId,
    openMarketplaceOptions,
    selectedMarketplace,
    anchorElMenu3,
    handleCloseMarketplaceOptions,
    urlAffiliate,
    member,
    ...rest
  } = props
  const onMarketplacePage = useLocation().pathname.startsWith(
    '/marketplace',
  )
  return (
  <ul>
    <li>
      <a
        id="leftNavMarketplaces"
        href="#/"
        onClick={toggleMarketplacesDropdown}
        data-nav-active={marketplacesDropdownOpen || undefined}
      >
        <span data-hf="sidebar-icon">
          <FontAwesomeIcon icon={['fas', 'sign-hanging']} />
        </span>
        <span data-hf="sidebar-item-label">Marketplaces</span>
        <span data-hf="sidebar-icon-indicator">
          <ChevronRightTwoToneIcon />
        </span>
      </a>
      <Collapse in={marketplacesDropdownOpen}>
        <ul>
          {!urlAffiliate && (
            <li>
              <NavLink
                id="leftNavMarketplacesHousefoliosMarketplace"
                onClick={() => handleMarketplace(null)}
                to="/marketplace"
                data-nav-active={
                  onMarketplacePage && !activeMarketplaceId
                    ? true
                    : undefined
                }
                aria-current={
                  onMarketplacePage && !activeMarketplaceId
                    ? 'page'
                    : 'false'
                }
              >
                {member === 'RWN'
                  ? 'All Properties'
                  : 'Housefolios Marketplace'}
              </NavLink>
            </li>
          )}
          {marketplaces.map((marketplace, index) => (
            <li
              key={marketplace.url || `marketplace-${index}`}
              data-hf="hover-show-hide-container"
            >
              <Box sx={{
                "& [data-hf-hover=\"show\"]": { display: "none" },
                "& [data-hf-hover=\"hide\"]": { display: "block" },
                "&:hover [data-hf-hover=\"show\"]": { display: "block" },
                "&:hover [data-hf-hover=\"hide\"]": { display: "none" },
              }}>
              <Link
                onClick={() => handleMarketplace(marketplace.url)}
                to="/marketplace"
                {...marketplaceNavActive(
                  String(activeMarketplaceId) === String(marketplace.url),
                  onMarketplacePage,
                )}
              >
                <Grid container direction="row" wrap="nowrap" sx={sidebarRowGridSx}>
                  <Grid size="grow">
                    <Typography sx={sidebarRowNameSx}>
                      {marketplace.name}
                    </Typography>
                  </Grid>
                  <Grid size="auto" data-hf-hover="hide" sx={sidebarRowCountColSx}>
                    <Typography>
                      {marketplace.propertyCount || 0}
                    </Typography>
                  </Grid>
                  <Grid
                    size="auto"
                    data-hf-grid="keep"
                    data-hf-hover="show"
                    sx={sidebarRowActionsColSx}
                  >
                    <Tooltip
                      title="Marketplace Actions"
                      slotProps={{ tooltip: { sx: {
                        bgcolor: "#4191ff",
                        "& .MuiTooltip-arrow": { color: "#4191ff" },
                      } } }}
                      arrow
                    >
                      <IconButton
                        onClick={(event) =>
                          openMarketplaceOptions(event, marketplace)
                        }
                        sx={sidebarActionsBtnSx}
                        size="large"
                        data-hf="sidebar-actions-btn"
                      >
                        <MoreVertOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Link>
              </Box>
            </li>
          ))}
          {member !== 'RWN' && <AddMarketplace mainNav={true} />}
          {!isEmpty(sharedMarketplaces) && (
            <Box sx={sidebarSharedSectionLabelSx}>
              <Share sx={sidebarSharedSectionIconSx} />
              Shared Marketplaces
            </Box>
          )}
          {sharedMarketplaces.map((marketplace, index) => (
            <li
              key={marketplace.url ? `shared-${marketplace.url}` : `shared-marketplace-${index}`}
              data-hf="hover-show-hide-container"
            >
              <Box sx={{
                "& [data-hf-hover=\"show\"]": { display: "none" },
                "& [data-hf-hover=\"hide\"]": { display: "block" },
                "&:hover [data-hf-hover=\"show\"]": { display: "block" },
                "&:hover [data-hf-hover=\"hide\"]": { display: "none" },
              }}>
              <Link
                onClick={() => handleMarketplace(marketplace.url)}
                to="/marketplace"
                {...marketplaceNavActive(
                  String(activeMarketplaceId) === String(marketplace.url),
                  onMarketplacePage,
                )}
              >
                <Grid container direction="row" wrap="nowrap" sx={sidebarRowGridSx}>
                  <Grid size="grow">
                    <Typography sx={sidebarRowNameSx}>
                      {marketplace.name}
                    </Typography>
                  </Grid>
                  <Grid size="auto" data-hf-hover="hide" sx={sidebarRowCountColSx}>
                    <Typography>
                      {marketplace.propertyCount || 0}
                    </Typography>
                  </Grid>
                  <Grid
                    size="auto"
                    data-hf-grid="keep"
                    data-hf-hover="show"
                    sx={sidebarRowActionsColSx}
                  >
                    <RemoveSharedMarketplace
                      orgId={orgId}
                      marketplaceURL={marketplace.url}
                      sidebarMenu
                    />
                  </Grid>
                </Grid>
              </Link>
              </Box>
            </li>
          ))}
        </ul>
      </Collapse>
    </li>
    {/* Marketplace MoreVert */}
    {selectedMarketplace && (
      <Menu
        anchorEl={anchorElMenu3}
        keepMounted
        open={Boolean(anchorElMenu3)}
        onClose={handleCloseMarketplaceOptions}
        slotProps={{ list: { sx: { p: 0 } } }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <div>
          <List
            component="div"
            sx={{
              "& .MuiListItem-root.MuiListItem-button": { borderRadius: 0 },
              "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                color: "#368cff",
                background: "rgba(54, 140, 255, 0.05)",
                "&::before": { background: "#368cff" },
              },
            }}
            onClick={handleCloseMarketplaceOptions}
          >
            <ShareMarketplace
              sidebarMenu={true}
              marketplace={selectedMarketplace}
              activeOrg={rest.activeOrg}
            />
            <EditMarketplace
              listItem
              marketPlace={selectedMarketplace}
            />
          </List>
        </div>
      </Menu>
    )}
  </ul>
  )
}

export default MarketplacesSection
